export default __webpack_public_path__ + "static/media/delinquencyActive.1a990c08.svg";